import { AccordionMenuInputComponent } from '@features/client/order-workflow/components/accordion-menu-input/accordion-menu-input.component';
import { ToothCrossContainer } from '@features/client/order-workflow/containers/tooth-cross/tooth-cross.container';
import { PatientBirthdateAtComponent } from '@features/client/order-workflow/components/patient-birthdate-at/patient-birthdate-at.component';
import { GraphicOneComponent } from '@features/client/order-workflow/components/graphic-one/graphic-one.component';
import { GraphicTwoComponent } from '@features/client/order-workflow/components/graphic-two/graphic-two.component';
import { LocationSelectionInputComponent } from '@features/client/order-workflow/components/location-selection-input/location-selection-input.component';

export const inputTypeComponents = [
  { name: 'patient_birthdate_at', component: PatientBirthdateAtComponent },
  { name: 'accordion_menu', component: AccordionMenuInputComponent },
  { name: 'tooth_cross', component: ToothCrossContainer },
  { name: 'graphic1', component: GraphicOneComponent },
  { name: 'graphic2', component: GraphicTwoComponent },
  { name: 'location_selection', component: LocationSelectionInputComponent },
];
